import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

const FormView = () => {
  const { id } = useParams();
  const [form, setForm] = useState(null);

  useEffect(() => {
    const forms = JSON.parse(localStorage.getItem('savedForms') || '[]');
    const selectedForm = forms.find(f => f.id === id);
    setForm(selectedForm);
  }, [id]);

  if (!form) {
    return <div>Loading...</div>;
  }

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold">{form.name}</h1>
      <p className="mt-4">{form.description}</p>
      {/* Render other form details as needed */}
    </div>
  );
};

export default FormView; 